import { render, staticRenderFns } from "./AdminTitle.vue?vue&type=template&id=a782f418&"
import script from "./AdminTitle.vue?vue&type=script&lang=js&"
export * from "./AdminTitle.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/views/admin/admin-title.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports